module.exports = __webpack_public_path__ + "onboarding-feed-docker.ce9ae8dc3930e09f17280f39b933f337.hashedasset.svg";